import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  ssDialogService,
  loaderService,
  reportsDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
  downloadDocument,
} from 'app/components/global';
import controller from './schematic.controller';
import directive from './schematic.directive';


export default angular.module('app.components.advisory.bcp.schematic', [
  alerts,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  constants,
  downloadDocument,
  ssDialogService,
  loaderService,
  reportsDataService,
])
  .directive('bcpSchematic', directive)
  .controller('SchematicController', controller)
  .name;

console.log('app.components.advisory.bcp.schematic created');
